import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

export const StyledReportRow = styled.div(
  props => css`
    margin-bottom: ${layout.measurements.spacing050};
    margin-top: ${layout.measurements.spacing075};
    padding: 0 ${layout.measurements.spacing100};
    border-radius: 8px;
    color: ${props.theme.text.secondary};
    background: ${props.theme.colors.base100};
  `
);

export const StyledAlternativePricesArea = styled.div`
  background-color: ${props => props.theme.colors.base100};

  padding: 0.75rem;
  padding-top: 0;

  > div {
    box-shadow: rgb(230 232 234) 0px 0px 0px 1px;
  }
`;

export const StyledInfoRow = styled.div`
  background-color: ${props => props.theme.colors.base100};
`;

export const StyledExpandButtonWrapper = styled.div`
  align-items: stretch;
  min-width: ${layout.measurements.spacing200};
`;
